/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewZoomyDomainConfidenceMapScoreItem
 */
export interface CRSFSecReviewZoomyDomainConfidenceMapScoreItem {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewZoomyDomainConfidenceMapScoreItem
     */
    dns_score: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewZoomyDomainConfidenceMapScoreItem
     */
    favicon_score: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewZoomyDomainConfidenceMapScoreItem
     */
    hyperlinks_score?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewZoomyDomainConfidenceMapScoreItem
     */
    ip_score: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewZoomyDomainConfidenceMapScoreItem
     */
    is_parked_score: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewZoomyDomainConfidenceMapScoreItem
     */
    named_entities_high_conf_score?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewZoomyDomainConfidenceMapScoreItem
     */
    named_entities_low_conf_score?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewZoomyDomainConfidenceMapScoreItem
     */
    redirects_score: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewZoomyDomainConfidenceMapScoreItem
     */
    serpapi_acquisition_score: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewZoomyDomainConfidenceMapScoreItem
     */
    ssl_subject_org_score: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewZoomyDomainConfidenceMapScoreItem
     */
    string_score: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewZoomyDomainConfidenceMapScoreItem
     */
    trackers_score: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewZoomyDomainConfidenceMapScoreItem
     */
    whois_score: number;
}

/**
 * Check if a given object implements the CRSFSecReviewZoomyDomainConfidenceMapScoreItem interface.
 */
export function instanceOfCRSFSecReviewZoomyDomainConfidenceMapScoreItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "dns_score" in value;
    isInstance = isInstance && "favicon_score" in value;
    isInstance = isInstance && "ip_score" in value;
    isInstance = isInstance && "is_parked_score" in value;
    isInstance = isInstance && "redirects_score" in value;
    isInstance = isInstance && "serpapi_acquisition_score" in value;
    isInstance = isInstance && "ssl_subject_org_score" in value;
    isInstance = isInstance && "string_score" in value;
    isInstance = isInstance && "trackers_score" in value;
    isInstance = isInstance && "whois_score" in value;

    return isInstance;
}

export function CRSFSecReviewZoomyDomainConfidenceMapScoreItemFromJSON(json: any): CRSFSecReviewZoomyDomainConfidenceMapScoreItem {
    return CRSFSecReviewZoomyDomainConfidenceMapScoreItemFromJSONTyped(json, false);
}

export function CRSFSecReviewZoomyDomainConfidenceMapScoreItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewZoomyDomainConfidenceMapScoreItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dns_score': json['dns_score'],
        'favicon_score': json['favicon_score'],
        'hyperlinks_score': !exists(json, 'hyperlinks_score') ? undefined : json['hyperlinks_score'],
        'ip_score': json['ip_score'],
        'is_parked_score': json['is_parked_score'],
        'named_entities_high_conf_score': !exists(json, 'named_entities_high_conf_score') ? undefined : json['named_entities_high_conf_score'],
        'named_entities_low_conf_score': !exists(json, 'named_entities_low_conf_score') ? undefined : json['named_entities_low_conf_score'],
        'redirects_score': json['redirects_score'],
        'serpapi_acquisition_score': json['serpapi_acquisition_score'],
        'ssl_subject_org_score': json['ssl_subject_org_score'],
        'string_score': json['string_score'],
        'trackers_score': json['trackers_score'],
        'whois_score': json['whois_score'],
    };
}

export function CRSFSecReviewZoomyDomainConfidenceMapScoreItemToJSON(value?: CRSFSecReviewZoomyDomainConfidenceMapScoreItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dns_score': value.dns_score,
        'favicon_score': value.favicon_score,
        'hyperlinks_score': value.hyperlinks_score,
        'ip_score': value.ip_score,
        'is_parked_score': value.is_parked_score,
        'named_entities_high_conf_score': value.named_entities_high_conf_score,
        'named_entities_low_conf_score': value.named_entities_low_conf_score,
        'redirects_score': value.redirects_score,
        'serpapi_acquisition_score': value.serpapi_acquisition_score,
        'ssl_subject_org_score': value.ssl_subject_org_score,
        'string_score': value.string_score,
        'trackers_score': value.trackers_score,
        'whois_score': value.whois_score,
    };
}

